export default ({
    control: {
        // backgroundColor: '#fff',
        // fontSize: 15,
        fontWeight: 'normal',
    },

    input: {
        margin: 0,
    },

    '&singleLine': {
        control: {
            // display: 'inline-block',
            // width: 130,
        },

        highlighter: {
            padding: 6.5,
        },

        input: {
            padding: 6.5,
            minHeight: 30,
            maxHeight: 35,
            outline: 0,
            width: '100%'
            // border: 0,
        },
    },

    '&multiLine': {
        control: {
            // fontFamily: 'monospace',
            // border: '1px solid silver',
        },

        highlighter: {
            padding: 6.5,
        },

        input: {
            padding: 6.5,
            minHeight: 30,
            whiteSpace: 'nowrap',
            maxHeight: 35,
            outline: 0,
            // border: 0,
        },
    },

    suggestions: {
        list: {
            backgroundColor: 'white',
            border: '1px solid rgba(0,0,0,0.15)',
            fontSize: 14,
            maxWidth: '100%',
            minWidth: '200px',
            top: '12px',
            maxHeight: '200px',
            overflow: "auto",
            position: "absolute"
        },

        item: {
            padding: '5px 15px',
            borderBottom: '1px solid rgba(0,0,0,0.15)',

            '&focused': {
                backgroundColor: '#cee4e5',
            },
        },
    },
})